export * from './lib/shared-svg-icon.module';
export * from './lib/svg-icon/svg-icon';
